import Activity from '../activity';

import './index.scss';
import { handleApiError } from 'utils/api_error_handler';
import { EventManager } from 'utils/event_manager';
import autosize from 'autosize';

class NewActivity {
  constructor($context) {
    const $component = $('.q-timeline-page');
    this.$context = $context;

    if (gon.qc_user || gon.institutional_publisher) {
      this._configureS3();
    }

    if ($component.length) {
      this._performByRole();
    }
  }

  _resetTextarea($newActivityTextarea, $submitButton, message) {
    $submitButton.removeClass('loading');
    this._setNewActivityTextareaValue($newActivityTextarea, message);
  }

  _getNewActivityTextareaValue($newActivityTextarea) {
    return this._editor ? $newActivityTextarea.html() : $newActivityTextarea.val();
  }

  _setNewActivityTextareaValue($newActivityTextarea, value) {
    if (this._editor) {
      $newActivityTextarea.html(value);
    } else {
      $newActivityTextarea.val(value);
    }
  }

  _setNewActivityTextarea($messageForm) {
    return this._editor ? $('.ql-editor', $messageForm) : $('.js-new-activity-textarea', $messageForm);
  }

  _configureS3() {
    const bucketName = gon.timeline_bucket_name;
    const bucketRegion = gon.timeline_bucket_region;
    const identityPoolId = gon.timeline_s3_identity_pool_id;

    window.AWS.config.update({
      region: bucketRegion,
      credentials: new window.AWS.CognitoIdentityCredentials({
        IdentityPoolId: identityPoolId
      })
    });

    this.s3 = new window.AWS.S3({
      apiVersion: '2006-03-01',
      params: { Bucket: bucketName }
    });
  }

  _quillInsertToEditor(url) {
    const range = this._editor.getSelection();
    this._editor.insertEmbed(range.index, 'image', url);
  }

  _quillAddImage(file) {
    const self = this;
    const randomId = new Date().getTime();
    const fileName = `${randomId + '.' + file.name.split('.').pop()}`;

    this.s3.upload(
      {
        Key: fileName,
        Body: file,
        ACL: 'public-read'
      },
      function (err, data) {
        if (err) {
          toastr.error('Ops! Ocorreu um erro ao enviar sua foto!');
          Rollbar.error(err.message, err);
        }
        self._quillInsertToEditor(data.Location);
      }
    );
  }

  _quillSelectLocalImage() {
    const self = this;
    const input = document.createElement('input');

    input.setAttribute('type', 'file');
    input.click();

    input.onchange = () => {
      const file = input.files[0];

      if (/^image\//.test(file.type)) {
        self._quillAddImage(file);
      } else {
        toastr.error('Ops! Você só pode enviar imagens');
      }
    };
  }

  _instantiateQuill() {
    const placeholder = $('.js-new-activity').data().placeholder;

    this._editor = new Quill('.js-editor-container', {
      modules: {
        toolbar: [['bold', 'italic', 'underline', 'link'], [{ color: [false, 'red', 'green', 'blue'] }], ['image']]
      },
      placeholder: placeholder,
      theme: 'snow'
    });

    this._editor.getModule('toolbar').addHandler('image', () => {
      this._quillSelectLocalImage();
    });
  }

  _createEventInActivityArea($newActivityTextarea) {
    $newActivityTextarea
      .on('focus', () => {
        $newActivityTextarea.parents('.q-dialog').addClass('q-dialog--focused');
      })
      .on('blur', () => {
        $newActivityTextarea.parents('.q-dialog').removeClass('q-dialog--focused');
      });
  }

  _toggleSubmitButton($submitButton, res) {
    $submitButton.attr('disabled', res ? false : 'disabled');
  }

  _publishActivity(message, $submitButton, $newActivityTextarea) {
    Activity.publish(message)
      .then(response => {
        $submitButton.attr('disabled', false).removeClass('loading');
        $newActivityTextarea.get(0).dispatchEvent(new Event('autosize:update'));
        EventManager.publish('timeline.activity.new', response.data);
      })
      .catch(({ response }) => {
        this._resetTextarea($newActivityTextarea, $submitButton, message);
        handleApiError('Ops! Não foi possível criar a sua publicação nesse momento!', response);
      });
  }

  _createEventInSubmitButton($submitButton, $newActivityTextarea) {
    $newActivityTextarea.keyup(() => {
      let isValid = this._getNewActivityTextareaValue($newActivityTextarea).length > 2;
      this._toggleSubmitButton($submitButton, isValid);
    });

    $submitButton.on('click', e => {
      e.preventDefault();
      let message = this._getNewActivityTextareaValue($newActivityTextarea);
      this._setNewActivityTextareaValue($newActivityTextarea, '');

      $submitButton.attr('disabled', 'disabled').addClass('loading');

      this._publishActivity(message, $submitButton, $newActivityTextarea);
    });
  }

  _performsMainInteraction() {
    const $messageForm = $('.js-new-activity-form');
    const $newActivityTextarea = this._setNewActivityTextarea($messageForm);
    const $submitButton = $('.js-new-activity-submit-btn', $messageForm);

    vendorManager.ensure('autosize', () => {
      autosize($newActivityTextarea.get(0));
    });

    this._createEventInActivityArea($newActivityTextarea);
    this._createEventInSubmitButton($submitButton, $newActivityTextarea);
  }

  _performByRole() {
    if ($('.js-editor-container', this.$context).length === 0) {
      this._performsMainInteraction();
    } else {
      vendorManager.ensure('quill', () => {
        this._instantiateQuill();
        this._performsMainInteraction();
      });
    }
  }
}

(function () {
  new NewActivity('.js-new-activity-form');
})();
